module.exports = __webpack_public_path__ + "img/bio-matthew-perkins.768f158d.png";